import { NgModule } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApButtonComponent } from '@ap/button';

import { ConversationalLinkComponent } from './conversational-link.component';

/**
 * @ngdoc module
 * @name ConversationalLinkModule
 **/
@NgModule({
    declarations: [ConversationalLinkComponent],
    exports: [ConversationalLinkComponent],
    imports: [ApButtonComponent, ApContentPipe],
    providers: [ApContentService]
})
export class ConversationalLinkModule {}
